import { twMerge } from "tailwind-merge";
import { AppType } from "@shared/types/app.types";
import { ThemeType } from "@shared/types/style.types";
import { Type } from "@shared/ui/Type";
import { ActionButtonsGroup } from "@shared/ui/ActionButtonsGroup";

export type CallToActionProps = {
  title: string;
  description?: string;
  className?: string;
  theme?: ThemeType;
  variant?: AppType;
  onSecondaryClick?: () => void;
  onPrimaryClick?: () => void;
  secondaryButtonText?: string;
  primaryButtonText?: string;
};

export const CallToAction = ({
  title,
  description,
  className,
  theme = "dark",
  variant = "platform",
  onSecondaryClick,
  onPrimaryClick,
  secondaryButtonText,
  primaryButtonText,
}: CallToActionProps) => {
  return (
    <div
      className={twMerge(
        "flex flex-col flex-wrap px-4 py-8 rounded-lg gap-8 md:p-8 md:flex-row md:justify-between",
        theme === "light" &&
          "bg-brand-50 text-brand-800 border border-brand-800",
        theme === "dark" && "bg-brand-800 text-brand-50",
        className
      )}
    >
      <div
        className={twMerge(
          "flex flex-col",
          variant === "platform" && "gap-6",
          variant === "portal" && "gap-3"
        )}
      >
        <Type
          variant={variant === "platform" ? "h3" : "h4"}
          className="max-w-3xl"
        >
          {title}
        </Type>
        {description && (
          <Type variant={variant === "platform" ? "body1" : "body2"}>
            {description}
          </Type>
        )}
      </div>
      <ActionButtonsGroup
        theme={theme}
        onSecondaryClick={onSecondaryClick}
        onPrimaryClick={onPrimaryClick}
        secondaryButtonText={secondaryButtonText}
        primaryButtonText={primaryButtonText}
      />
    </div>
  );
};

export default CallToAction;
